var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-panel',{scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.loading)?_c('loading-spinner',{attrs:{"line":"","height":"10px"}}):_vm._e(),_c('menu-home',{attrs:{"options":_vm.options}})]},proxy:true},{key:"buttons",fn:function(){return [_c('logout-button')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }